import axios from 'axios';

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const code = error.response.data?.code;
      if (code === 'TOKEN_EXPIRED') {
        alert('Session Expired. Please log in again.');
      }
      
      // Clear auth from local storage
      localStorage.removeItem('user');
      localStorage.removeItem('user_info');
      sessionStorage.clear();

      window.location.href = '/login'; 
    }
    return Promise.reject(error);
  }
);

export default axios;
